import * as React from "react";
import { SVGProps, memo } from "react";
const SvgWarningIcon12Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    role="img"
    {...props}
  >
    <path
      d="M5.11 1.492a1 1 0 0 1 1.78 0l4.116 8.053a1 1 0 0 1-.89 1.455H1.884a1 1 0 0 1-.89-1.455L5.11 1.492Z"
      fill="#FECA63"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 9v1h-1V9h1Zm0-6v5h-1V3h1Z"
      fill="#333"
    />
  </svg>
);
const Memo = memo(SvgWarningIcon12Px);
export default Memo;
